module.exports = __webpack_public_path__ + "static/media/jhon_and_george_thumb.be60b037.jpg";